import { X } from "lucide-react";
import { useId, type KeyboardEvent, type MouseEvent, type ReactNode, type RefObject, type SyntheticEvent } from "react";

export function ApprovalDetailDialogMarkup({
  formNo,
  departmentName,
  lineName,
  busy,
  children,
  revisionControl,
  onClose,
  dialogRef,
  closeButtonRef,
  onCancel,
  onMouseDown,
  onKeyDown,
}: {
  formNo: string;
  departmentName: string | null;
  lineName: string | null;
  busy: boolean;
  children: ReactNode;
  revisionControl?: ReactNode;
  onClose: () => void;
  dialogRef?: RefObject<HTMLDialogElement | null>;
  closeButtonRef?: RefObject<HTMLButtonElement | null>;
  onCancel?: (event: SyntheticEvent<HTMLDialogElement>) => void;
  onMouseDown?: (event: MouseEvent<HTMLDialogElement>) => void;
  onKeyDown?: (event: KeyboardEvent<HTMLDialogElement>) => void;
}) {
  const titleId = useId();
  return (
    <dialog ref={dialogRef} className="shift-approval-dialog" aria-modal="true" aria-labelledby={titleId} onCancel={onCancel} onMouseDown={onMouseDown} onKeyDown={onKeyDown}>
      <section className="shift-approval-dialog-panel">
        <header className="shift-approval-dialog-header">
          <div className="shift-approval-dialog-title">
            <h2 className="sr-only" id={titleId}>{formNo}</h2>
            {departmentName || lineName ? (
              <small>{[departmentName, lineName].filter(Boolean).join(" · ")}</small>
            ) : null}
          </div>
          {revisionControl}
          <button ref={closeButtonRef} type="button" aria-label="Kapat" disabled={busy} onClick={onClose}>
            <X size={20} aria-hidden="true" />
          </button>
        </header>
        <div className="shift-approval-dialog-body">{children}</div>
      </section>
    </dialog>
  );
}
